import {
  IconCashBanknote,
  IconNotebook,
  IconReceipt2,
} from "@tabler/icons-react";
import { ModuleLanding, NoteText } from "../../shell/ModuleLanding";

/**
 * The Collections module.
 *
 * It is a module of its own rather than a screen inside Marketing because
 * taking money is a separate job from creating demand, and the person who
 * only collects should not be handed the day order form as well.
 *
 * THREE TILES, AND "COLLECT PAYMENT" IS NOT ONE OF THEM
 *
 * Outstanding, Record payment, and the register.
 *
 * Collecting against one of OUR bills starts from Outstanding and always did:
 * every row on that list links straight into the collection form for that
 * bill, which is the only thing anybody goes there to do. The tile was a
 * second door into the same screen, and its own first step - typing the bill
 * number off the customer's copy - answers a question Outstanding already
 * answers better, because every unpaid bill is on it.
 *
 * So the screen is untouched and still reached the way it is actually used.
 * What took its place on this page is the thing that had no door at all:
 * recording a payment for a bill this application never raised.
 */
export function CollectionsHome() {
  return (
    <ModuleLanding
      title="Collections"
      // Not "against issued bills" any more: half of what this module now
      // records is against a bill issued somewhere else entirely.
      subtitle="Money collected in the field"
      tiles={[
        {
          to: "/collections/outstanding",
          label: "Outstanding",
          blurb: "Every bill with money still owed, and how much",
          icon: <IconReceipt2 size={21} stroke={1.6} />,
        },
        {
          to: "/collections/record",
          label: "Record payment",
          blurb: "For a bill raised on another system — find the customer",
          icon: <IconCashBanknote size={21} stroke={1.6} />,
        },
        {
          to: "/collections/payments",
          label: "Payments recorded",
          blurb: "Every receipt taken, both kinds",
          icon: <IconNotebook size={21} stroke={1.6} />,
        },
      ]}
      noteTitle="How it works"
      note={
        <NoteText>
          For one of our bills, start from Outstanding and open the bill — the
          amount you record cannot exceed what is still owed. For a bill raised
          on another system, use Record payment and find the customer by name;
          there is no balance here to check it against, so that one takes the
          customer&apos;s signature as well as a photo and location.
        </NoteText>
      }
    />
  );
}
